import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import Slider from "react-slick";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { openPopup } from "../../store/popupSlice"
import { BaseUrl } from "../helper/BaseUrl";
import { ApiEndpoints } from "../helper/ApiEndpoints";
import ApiRequest from "../helper/ApiRequest";

const testimonialListEndpoint = ApiEndpoints.VideoTestimonial.testimonialView;
const asList = (value) => (Array.isArray(value) ? value : []);

export default function ShuttleAppreciation({title="", initialData}) {

  const [isPopupVisible, setPopupVisible] = useState(false);
  const [currentVideo, setCurrentVideo] = useState("");
  const [data, setData] = useState(() => asList(initialData));

  const dataFetch = useCallback(async () => {
    try {
      const response = await ApiRequest("GET", testimonialListEndpoint);
      const result = response.video_testimonials;
      setData(asList(result));
    } catch (error) {
      console.error(error);
    }
  }, []);


  useEffect(() => {
    if (data.length) return;
    dataFetch();
  }, [data.length, dataFetch]);

  const dispatch = useDispatch();

  const settings = useMemo(
    () => ({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 1500,
      autoplaySpeed: 3500,
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: true,
      pauseOnHover: true,
      cssEase: "ease",
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            centerMode: false,
          },
        },
      ],
    }),
    []
  );

  const openPopup2 = useCallback((videoSrc) => {
    const url = videoSrc.includes("?")
      ? `${videoSrc}&autoplay=1`
      : `${videoSrc}?autoplay=1`;
    setCurrentVideo(url);
    setPopupVisible(true);
  }, []);

  const closePopup = useCallback(() => {
    setPopupVisible(false);
    setCurrentVideo("");
  }, []);

  return (
    <>
      <section className="appreciate-word">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              {title?(
                <h2 className="heading center-heading">
                {title}
              </h2>
              ):(
                <h2 className="heading center-heading">
                They loved our work<br /> we love <span className="gradiant-color">their words of appreciation</span>
              </h2>
              ) }
            </div>

            <div className="col-lg-12">
              <div className="inner-youtube-testimonial">
                <Slider className="testimonial-slider youtube-slider" {...settings}>
                  {data && data.map((item, index) => (
                    <div key={index} className="youtube-testimonial" onClick={() => openPopup2(`${item.url}`)}>
                      <div className="yout-test-wrap">
                        <img loading="lazy" src={`${BaseUrl}${item.thumbnail}`} alt="video" className="img-responsive" />
                        <span className="play-butn"><FontAwesomeIcon icon={faPlay} /></span>
                      </div>
                      <span><img loading="lazy" src="/assets/home/youtube-testimonial-logo.webp" alt="logo" className="img-responsive" /></span>
                    </div>
                  ))}

                  {/* <div className="youtube-testimonial" onClick={() => openPopup2("https://www.youtube.com/embed/TzRiWTRotzY?si=vmyBB4LJlQBw7HRU")}>
                    <div className="yout-test-wrap">
                      <img loading="lazy" src="/assets/home/youtube-video-1.webp" alt="video" className="img-responsive" />
                      <span className="play-butn"><FontAwesomeIcon icon={faPlay} /></span>
                    </div>
                    <span><img loading="lazy" src="/assets/home/youtube-testimonial-logo.webp" alt="logo" className="img-responsive" /></span>
                  </div> */}
                </Slider>
              </div>
            </div>

            <div className="col-lg-12 text-center">
              <Link to="" onClick={() => dispatch(openPopup())} className="default-btn animated-btn">
                make an appointment
              </Link>
            </div>
          </div>
        </div>
      </section>

      {isPopupVisible && (
        <div className="tube-test-video-popup">
          <div className="tube-test-popup-overlay" onClick={closePopup}></div>
          <div className="tube-test-popup-content">
            <button className="tube-test-close-btn" onClick={closePopup}>
              ✖
            </button>
            <iframe
              src={currentVideo}
              title="YouTube video player"
              allow="autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </>
  );
}
